import { render } from "./HuviringidView.vue?vue&type=template&id=66651e4d"
import script from "./HuviringidView.vue?vue&type=script&lang=js"
export * from "./HuviringidView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__